export default __webpack_public_path__ + "img/00a89ccdfb02c7601bf0d93787edeb04.jpeg";